import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verifyAdmin = async () => {
            const token = localStorage.getItem("adminToken");

            if (!token) {
                setAdmin(null);
                setIsAdminAuthenticated(false);
                setLoading(false);
                return;
            }

            try {
                const response = await axios.get("https://bloodinoureyes.com/api/admin/me", {
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (response.data.admin) {
                    setAdmin(response.data.admin);
                    setIsAdminAuthenticated(true);
                } else {
                    throw new Error("No admin data in response");
                }
            } catch (error) {
                console.error("Admin verification failed:", error.response?.data || error.message);
                localStorage.removeItem("adminToken"); // Clear invalid token
                setAdmin(null);
                setIsAdminAuthenticated(false);
            } finally {
                setLoading(false);
            }
        };

        verifyAdmin();
    }, []);

    const loginAdmin = async (email, password) => {
        try {
            const response = await axios.post("https://bloodinoureyes.com/api/admin/login", { email, password });
            const { token, admin } = response.data;

            localStorage.setItem("adminToken", token);
            setAdmin(admin);
            setIsAdminAuthenticated(true);
        } catch (error) {
            console.error("Login failed:", error.response?.data?.message || error.message);
            throw error;
        }
    };

    const logoutAdmin = () => {
        localStorage.removeItem("adminToken");
        setAdmin(null);
        setIsAdminAuthenticated(false);
    };

    return (
        <AuthContext.Provider value={{ admin, isAdminAuthenticated, loading, loginAdmin, logoutAdmin }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
